import React, { useEffect, useState } from "react";
import axios from "axios";

const containerStyle = {
  maxWidth: "1400px",
  margin: "0 2px",
  marginTop: "60px",
  backgroundColor: 'rgb(177 93 198)',
  borderRadius: "10px"
};

const baseCardStyle = {
  backgroundColor: "#fff",
  border: "1px solid gold",
  borderRadius: "16px",
  padding: "35px 30px",
  width: "460px",
  boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
  textAlign: "center",
  transition: "all 0.3s ease-in-out",
  cursor: "default",
};

const cardHoverStyle = {
  backgroundColor: 'rgb(177 93 198)',
  color: "#fff",
  transform: "translateY(-8px)",
  boxShadow: "0 12px 24px rgba(0, 0, 0, 0.15)",
};

const iconBaseStyle = {
  fontSize: "56px",
  marginBottom: "20px",
  transition: "color 0.3s ease",
};

const titleBaseStyle = {
  fontSize: "26px",
  fontWeight: "700",
  marginBottom: "14px",
  transition: "color 0.3s ease",
};

const descBaseStyle = {
  fontSize: "16px",
  lineHeight: "1.6",
  transition: "color 0.3s ease",
  textAlign: "justify",
};

const sectionTitleStyle = {
  textAlign: "center",
  fontSize: "30px",
  fontWeight: "800",
  color: "rgb(255 225 36)",
  letterSpacing: "0.5px",
  marginTop: "10px",
  fontFamily: 'revert'
};

const CateringCard = ({ icon, title, description, isMobile }) => {
  const [hovered, setHovered] = useState(false);

  const mergedCardStyle = {
    ...baseCardStyle,
    ...(hovered ? cardHoverStyle : {}),
    width: isMobile ? "90%" : "460px",
    maxWidth: "100%",
  };

  const iconStyle = {
    ...iconBaseStyle,
    color: hovered ? "#fff" : "#ee6521",
  };

  const titleStyle = {
    ...titleBaseStyle,
    color: hovered ? "#fff" : "#333",
  };

  const descStyle = {
    ...descBaseStyle,
    color: hovered ? "#eee" : "#666",
  };

  return (
    <div
      style={mergedCardStyle}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <div style={iconStyle}>{icon}</div>
      <h3 style={titleStyle}>{title}</h3>
      <p style={descStyle}>{description}</p>
    </div>
  );
};

const CateringMissionVisionCards = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [vendorId, setVendorId] = useState(null);
  const [mission, setMission] = useState("");
  const [vision, setVision] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    const storedVendorId = localStorage.getItem("vendorId");
    setVendorId(storedVendorId);
  }, []);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const cardWrapperStyle = {
    display: "flex",
    flexDirection: isMobile ? "column" : "row",
    alignItems: "center",
    justifyContent: "center",
    gap: "40px",
    padding: "40px",
    borderRadius: "20px",
    overflowX: isMobile ? "hidden" : "auto",
  };

  useEffect(() => {
    if (!vendorId) return;
    const controller = new AbortController();
    const token = localStorage.getItem("authToken");

    (async () => {
      try {
        setLoading(true);

        const { data } = await axios.get(
          `http://10.10.20.9:7007/caterings-0.0.1-SNAPSHOT/api/aboutus/${vendorId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
            signal: controller.signal,
          }
        );

        setMission(data?.mission ?? "");
        setVision(data?.vision ?? "");
      } catch (err) {
        if (!axios.isCancel(err)) setError("Couldn't load mission & vision");
      } finally {
        setLoading(false);
      }
    })();

    return () => controller.abort();
  }, [vendorId]);

  return (
    <section style={containerStyle}>
      <h1 style={sectionTitleStyle}>OUR COMMITMENTS</h1>

      <div style={cardWrapperStyle}>
        <CateringCard
          icon="🎯"
          title="Our Mission"
          description={mission}
          isMobile={isMobile}
        />
        <CateringCard
          icon="🌟"
          title="Our Vision"
          description={vision}
          isMobile={isMobile}
        />
      </div>
    </section>
  );
};

export default CateringMissionVisionCards;












